
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Card from 'vux/src/components/card/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import RoundReportMatchSimple from './round_report_matchSimple.vue'
import RoundReportUnStartMatchSimple from './round_report_matchSimpleUnstart.vue'
export default {
props: {
roundInfo: Object
},
components: {
Flexbox,
FlexboxItem,
Divider,
XButton,
RoundReportMatchSimple,
RoundReportUnStartMatchSimple
},
mounted(){

this.reload();
},
methods: {
reload(){
this.groups = this.roundInfo.groups;
},
},
data () {
return {
title:" ",
groups:[],
}
},
watch: {
roundInfo(curVal, oldVal){
this.reload();
}
}
}



// WEBPACK FOOTER //
// ./src/components/league/round_report_roundCard.vue